// Holistic Treatments Frome - Service Page
import ServicePageTemplate from "../../components/templates/ServicePageTemplate";

const HolisticTreatmentsFrome = () => {
  return (
    <ServicePageTemplate
      // SEO
      pageTitle="Holistic Treatments in Frome | Massage, Reiki & Energy"
      metaDescription="Holistic treatments in Frome, Somerset. Swedish massage, Reiki, chakra healing, crystal healing, and energy work with Annelie Lily."
      canonical="https://annelielily.com/treatments/holistic-treatments"
      
      // Hero
      heroLabel="Holistic Treatments in Frome"
      heroTitle="Healing & Energy Work"
      heroDescription="A range of holistic treatments designed to nurture balance, clarity, and wellbeing. From hands-on massage to subtle energy work, find the healing approach that resonates with you."
      heroImage="https://images.pexels.com/photos/3997993/pexels-photo-3997993.jpeg?auto=compress&cs=tinysrgb&w=800"
      
      // Content
      introTitle="Holistic Healing in Frome"
      introText={[
        "True wellbeing involves more than just the physical body. Annelie offers a range of holistic treatments that work with body, mind, and energy to support your journey towards balance and wholeness.",
        "Whether you're seeking deep physical relaxation through massage, energetic rebalancing through Reiki or chakra work, or guidance through a challenging time - there's a treatment to support you.",
        "All treatments take place in a calm, private space in Frome, Somerset. Each session is tailored to your needs on the day, creating a truly personalised healing experience."
      ]}
      
      // Benefits
      benefits={[
        {
          title: "Swedish Massage",
          description: "Classic massage therapy to release muscle tension, improve circulation, and promote deep relaxation.",
          link: "/treatments/swedish-massage"
        },
        {
          title: "Reiki Healing",
          description: "Gentle energy work that supports the body's natural healing ability and restores energetic balance.",
          link: "/treatments/reiki-healing"
        },
        {
          title: "Chakra Healing",
          description: "Working with the body's energy centres to release blocks, restore flow, and promote harmony.",
          link: "/treatments/chakra-healing"
        },
        {
          title: "Crystal Healing",
          description: "Using the natural energy and vibrations of crystals to support healing, relaxation and balance. Each crystal has unique properties that can help clear blockages and restore harmony."
        },
        {
          title: "AuraTransformation™",
          description: "A powerful one-off energy treatment that permanently expands your aura and balances your energy system. This profound process supports personal growth, clarity and a deeper connection to yourself."
        },
        {
          title: "Guidance Card Readings",
          description: "Using oracle and guidance cards as a tool for insight and reflection. These readings offer gentle messages to support your journey and help you gain clarity on your path."
        },
        {
          title: "Nutritional Healing",
          description: "Exploring how food and nutrition can support your overall wellbeing. Annelie offers guidance on nourishing your body in ways that complement your healing journey."
        },
        {
          title: "Guidance & Mentoring",
          description: "Supportive sessions for clarity, direction, and personal growth during life transitions. A safe space to explore your path with gentle, intuitive guidance."
        },
        {
          title: "Combination Treatments",
          description: "Bespoke sessions that combine two or more healing modalities, tailored to your specific needs. These blended treatments offer a holistic approach to support your mind, body and spirit."
        }
      ]}
      
      // Who is it for
      idealFor={[
        "Anyone experiencing stress, tension, or burnout",
        "Those seeking deep relaxation and rest",
        "People curious about energy healing and spiritual practices",
        "Anyone going through a life transition or challenging period",
        "Those wanting to complement their yoga practice with healing work",
        "People experiencing physical tension or chronic pain",
        "Anyone seeking greater clarity and direction in life"
      ]}
      
      // What to expect
      whatToExpect={[
        "Before your first treatment, you'll have a brief consultation to discuss your health history, current concerns, and what you hope to gain from the session. This helps Annelie tailor the treatment to your needs.",
        "Treatments take place in a warm, peaceful room with soft lighting and gentle music. For massage, you'll undress to your comfort level (always appropriately draped). For energy work, you remain fully clothed.",
        "During the treatment, you simply relax and receive. Annelie works intuitively, responding to what your body needs. Many people experience deep relaxation, emotional release, or profound stillness.",
        "After your treatment, you'll have time to slowly return to the world. Annelie may offer guidance on supporting the healing process at home. It's recommended to drink plenty of water and rest afterwards."
      ]}
      
      // FAQ
      faqs={[
        {
          question: "How do I know which treatment is right for me?",
          answer: "If you're unsure, Annelie is happy to have a conversation before you book. Generally: choose massage for physical tension, Reiki or chakra healing for energetic balance and relaxation, and guidance sessions for life direction and support."
        },
        {
          question: "Do I need to believe in energy healing for it to work?",
          answer: "An open mind is helpful, but you don't need to hold any particular beliefs. Many people approach energy work with curiosity rather than conviction and find it deeply relaxing and beneficial regardless."
        },
        {
          question: "How long does each treatment last?",
          answer: "Most treatments last 60-90 minutes including consultation time. AuraTransformation is a longer process. Specific durations and prices are available on enquiry."
        },
        {
          question: "Can treatments be combined with yoga?",
          answer: "Absolutely. Many clients combine regular yoga practice with occasional treatments. The two complement each other beautifully - yoga maintains day-to-day balance while treatments offer deeper release and reset."
        }
      ]}
      
      // Testimonials
      testimonials={[
        {
          quote: "Annelie has a very genuine and gentle approach. I felt incredibly relaxed and looked after throughout my treatment. She has a true gift for healing.",
          name: "Henry Felton"
        },
        {
          quote: "I came to Annelie feeling stressed and disconnected. After just one session, I felt like a different person. She has an intuitive understanding of what the body needs.",
          name: "Sabrina",
          location: "Exeter"
        }
      ]}
      
      // Related
      currentSlug="holistic-treatments-frome"
      
      // Schema
      serviceType="WellnessService"
      serviceName="Holistic Treatments in Frome"
      serviceDescription="Holistic healing treatments in Frome, Somerset including Swedish massage, Reiki, chakra healing, and energy work with Annelie Lily."
    />
  );
};

export default HolisticTreatmentsFrome;
